import ReactGA from "react-ga";

const trackEvent = (category, action, label = undefined) => {
  ReactGA.event({
    category,
    action,
    label,
  });
};

export default trackEvent;
